package top.wcpe.allincore.ui.runtime.element

import top.wcpe.allincore.layout.engine.LayoutMode
import kotlin.jvm.JvmStatic

/**
 * 滚动视图：内容超出自身视窗时滚动展示。默认垂直滚动，向后兼容历史行为。
 *
 * 布局上为列式（[LayoutMode.COLUMN]）：子元素自上而下排布，gap 为行间距。
 * 滚动状态、视窗/内容尺寸、钳制、滚轮/拖拽事件接管均由基类 [ScrollableContainer] 提供；
 * 裁剪、子节点偏移、viewport/content 同步由 `UIRenderer` 对 `ScrollableContainer` 的统一分支负责。
 *
 * [viewportHeight] / [contentHeight] 由渲染端按帧写入（已知盒尺寸时），之后任意 [scrollY] /
 * 滚轮事件都会基于最新 viewport/content 做 clamp。
 */
@Suppress("MagicNumber")
class ScrollView private constructor() : ScrollableContainer<ScrollView>() {

    init {
        // 默认列式布局：子元素垂直排布，符合「上下滚动列表」的常规预期。
        styleField.layout().mode = LayoutMode.COLUMN
    }

    override fun child(child: UIElement<*>): ScrollView {
        // 仅当子节点 flexShrink 仍为 LayoutStyle 默认值（1f）时强制改为 0：
        // ScrollView 的核心语义是子内容可超出视窗并滚动，默认 flexShrink=1 会让子内容
        // 被压到视窗内导致无东西可滚；调用者已显式设置（任何 != 1f 的值）则尊重其意图，
        // 由调用者自行承担「内容可能不滚动」的后果。
        // 注意：此处依赖 LayoutStyle.flexShrink 默认值为 1f；若默认值变化需同步更新。
        if (child.layoutStyle().flexShrink == 1f) {
            child.layoutStyle().flexShrink = 0f
        }
        return super.child(child)
    }

    protected override fun self(): ScrollView = this

    companion object {
        @JvmStatic
        fun create(): ScrollView = ScrollView()
    }
}
